import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';


@Component({
    selector: 'ecp-map-legend',
    templateUrl: './legend.component.html',
    styleUrls: ['./legend.component.css'],
    animations: [
        trigger('openClose', [
            state('open', style({
                right: '360px',
            })),
            state('closed', style({
                right: '0px',
            })),
            transition('open => closed', [
                animate('0.1s')
            ]),
            transition('closed => open', [
                animate('0.1s')
            ]),
        ]),
        trigger('legendFold', [
            state('open', style({
                width: '*',
                opacity: '1',
            })),
            state('closed', style({
                width: '0px',
                opacity: '0',
            })),
            transition('open => closed', [
                animate('0.1s')
            ]),
            transition('closed => open', [
                animate('0.1s')
            ]),
        ]),
    ]
})
export class LegendComponent implements OnInit {
    @Input() mapSideState = true; // ä¾§è¾¹æ æ¯å¦å±å¼
    legendFold = true; // å¾ä¾æ¯å¦æå 

    switchFold() {
        this.legendFold = !this.legendFold;
    }

    constructor() {
    }

    ngOnInit() {
    }

}
